import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { vkAuth } from '../api/auth';
import { useAuth } from '../context/AuthContext';

const VKCallback = () => {
  const navigate = useNavigate();
  const { loginWithTokens } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const device_id = params.get('device_id') || '';

    if (code) {
      vkAuth(code, device_id)
        .then(response => {
          loginWithTokens(response);
          navigate('/profile');
        })
        .catch(err => {
          console.error('VK callback error:', err);
          navigate('/login?error=vk_auth_failed');
        });
    } else {
      navigate('/login?error=no_code');
    }
  }, [loginWithTokens, navigate]);

  return <div className="min-h-screen flex items-center justify-center">Авторизация через VK...</div>;
};

export default VKCallback;
